<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader },
  data() {
    return {
      title: "Unverified Agent List",
      items: [
        {
          text: "Agent",
          href: "/",
        },
        {
          text: "Unverified Agent List",
          active: true,

        },
      ],
      agents: [],
        agent:[],
        agency:[],
        user:[],
        errors:null,
        visible:false,
        message:"",
        search_fname:"",
        search_lname:"",
        search_uname:"",
        search_email:"",
        search_phone:"",
        search_pcode:"",
        search_pnumber:"",
        search:"",
    };
  },
  mounted() {
    this.getAgentList();
  },
    computed: {
        filteredList() {
            return this.agents.filter(agent => {
                return agent.first_name.toLowerCase().includes(this.search_fname.toLowerCase())
                    || agent.last_name.toLowerCase().includes(this.search_fname.toLowerCase())
                    && (agent.users[0].username==null ? '' : agent.users[0].username).toLowerCase().includes(this.search_uname.toLowerCase())
                    && agent.email.toLowerCase().includes(this.search_email.toLowerCase())
            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },
      onClick(link){
          window.open(link);
      },
      async getAgentDetails(agent){
          let uuid=agent.uuid;
          try{
              axios
                  .post("/api/agent/detail/" + uuid, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.agent=response.data.data.data;
                          this.agency=response.data.data.data.agency_information[0];
                          this.user=response.data.data.data.users[0];
                      }else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async sendVerificationEmail(agent) {
          try {
              let userUuid=agent.users[0].uuid;
              axios
                  .post("/api/email-verification",{
                      accessToken: localStorage.getItem("access_tocken"),
                      uuid: userUuid,
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.$swal("Successfully send email verification link");
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    errorCheck(obj) {
          if(obj.statusCode==400){
              this.$swal("Email already Verified");
          }
        else if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    async deleteWarning(agent) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(agent);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getAgentList() {
      try {
        axios
          .get("/api/agent/unverified/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.agents = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },

    deleteItem: function deleteItem(agent) {
      var _this = this;
      axios
        .post("/api/agent/delete/" + agent.uuid, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
          _this.getAgentList();
          _this.hasDeleted = false;
        });
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-modal
                  id="modal-lg"
                  size="lg"
                  title="Agent Details"
                  title-class="font-18"
                  hide-footer
              >
                  <p>
                  <div v-if="agency!=undefined">
                      <h4>Agency Information</h4>
                  <table class="table-responsive">
                      <tr>
                          <td><img v-bind:src="agency.agency_logo" alt="logo"></td>

                      </tr>
                      <tr>
                          <td>Name</td>
                          <td v-if="agency.agency_name != null">{{agency.agency_name}}</td>
                          <td>Civil Aviation Certificate No.</td>
                          <td v-if="agency.civil_aviation_certificate_no != null">{{agency.civil_aviation_certificate_no}}</td><td v-else> N/A</td>

                      </tr>
                      <tr>
                          <td>Iata No.</td>
                          <td v-if="agency.iata_no != null">{{agency.iata_no}}</td><td v-else> N/A</td>
                          <td>Civil Aviation Certificate</td>
                          <td v-if="agency.civil_aviation_certificate_document != null">
                              <button class="btn btn-link" @click.prevent="onClick(agency.civil_aviation_certificate_document)">download</button>
                          </td>
                          <td v-else>
                              N/A
                          </td>


                      </tr>
                      <tr>
                          <td>Trade Licence No.</td>
                          <td v-if="agency.trade_license_no !=null">{{agency.trade_license_no}}</td>
                          <td v-else>
                              N/A
                          </td>
                          <td>Management Full Name</td>
                          <td v-if="agency.management_full_name != null">{{agency.management_full_name}}</td>
                          <td v-else>
                              N/A
                          </td>

                      </tr>
                      <tr>

                          <td>Postal Code</td>
                          <td v-if="agency.postal_code != null">{{agency.postal_code}}</td><td v-else> N/A</td>
                          <td>Management Ownership Title</td>
                          <td v-if="agency.management_ownership_title != null">{{agency.management_ownership_title}}</td><td v-else> N/A</td>

                      </tr>
                      <tr>

                          <td>Address</td>
                          <td v-if="agency.address != null">{{agency.address}}</td><td v-else>N/A</td>
                          <td>Management Phone No.</td>
                          <td v-if="agency.management_phone_number != null">{{agency.management_phone_number}}</td><td v-else>N/A</td>
                      </tr>
                      <tr>
                          <td>Website</td>
                          <td v-if="agency.website != null">{{agency.website}}</td><td v-else>N/A</td>
                          <td>Management Email</td>
                          <td v-if="agency.management_email != null">{{agency.management_email}}</td><td v-else>N/A</td>

                      </tr>
                      <tr>
                          <td>Fax</td>
                          <td v-if="agency.fax_no != null">{{agency.fax_no}}</td><td v-else>N/A</td>
                          <td>Contact Person Full Name</td>
                          <td v-if="agency.contact_person_full_name != null">{{agency.contact_person_full_name}}</td><td v-else>N/A</td>

                      </tr>
                      <tr>
                          <td>City</td>
                          <td v-if="agency.city != null">{{agency.city}}</td><td v-else>N/A</td>
                          <td>Contact Person Email</td>
                          <td v-if="agency.contact_person_email != null">{{agency.contact_person_email}}</td><td v-else>N/A</td>
                      </tr>
                      <tr>

                          <td>Country</td>
                          <td v-if="agency.country != null">{{agency.country}}</td><td v-else>N/A</td>
                          <td>Contact Person Phone No.</td>
                          <td v-if="agency.contact_person_phone_number != null">{{agency.contact_person_phone_number}}</td><td v-else>N/A</td>

                      </tr>
                      <tr>

                      </tr>
                      <tr>

                      </tr>

                  </table>
                  </div>
                  </p>
                  <p>
                  <div>
                      <h4>Agent Information</h4>
                      <table>
                          <tr>
                              <td>First Name</td>
                              <td>{{agent.first_name}}</td>

                              <td>Country Code</td>
                              <td>{{agent.country_code}}</td>
                          </tr>
                          <tr>
                              <td>Last Name</td>
                              <td>{{agent.last_name}}</td>

                              <td>Country</td>
                              <td>{{agent.country}}</td>
                          </tr>
                          <tr>
                              <td>Email</td>
                              <td>{{agent.email}}</td>

                              <td>Currency</td>
                              <td>{{agent.currency}}</td>
                          </tr>
                          <tr>
                              <td>Phone No</td>
                              <td>{{agent.phone_code}}{{agent.phone_number}}</td>

                              <td>Main Balance</td>
                              <td>{{agent.main_balance}}</td>
                          </tr>
                          <tr>
                              <td>Gender</td>
                              <td>{{agent.gender}}</td>

                              <td>Markup Amount</td>
                              <td>{{agent.markup_amount}}</td>
                          </tr>
                          <tr>
                              <td>Postal Code</td>
                              <td>{{agent.postal_code}}</td>

                              <td>Markup Type</td>
                              <td>{{agent.markup_type}}</td>
                          </tr>
                          <tr>
                              <td>City</td>
                              <td>{{agent.city}}</td>
                              <td> Language</td>
                              <td>{{agent.language}}</td>
                          </tr>
                      </table>
                  </div>
                  </p>
                  <p class="mb-0">
                  <div>
                      <h4>User Information</h4>
                      <table>
                          <tr>
                              <td>First Name</td>
                              <td>{{user.first_name}}</td>

                              <td>Display Picture</td>
                              <td><img class="width-20px" v-bind:src="user.display_picture" alt="Picture"></td>
                          </tr>
                          <tr>
                              <td>Last Name</td>
                              <td>{{user.last_name}}</td>

                              <td>Country Code</td>
                              <td>{{user.country_code}}</td>
                          </tr>
                          <tr>
                              <td>Email</td>
                              <td>{{user.email}}</td>

                              <td>Country</td>
                              <td>{{user.country}}</td>
                          </tr>
                          <tr>
                              <td>Phone No</td>
                              <td>{{user.phone_code}}{{user.phone_number}}</td>

                              <td>Account Status</td>
                              <td>{{user.status}}</td>
                          </tr>
                          <tr>
                              <td>Gender</td>
                              <td>{{user.gender}}</td>
                          </tr>
                      </table>
                  </div>
                  </p>
              </b-modal>
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Username</th>
                    <th>Name</th>
                    <th>Email/Phone</th>
                      <th>Email Verified</th>
                    <th>Address</th>
                      <th>Currency/Language</th>
                    <th>Action</th>
                  </tr>
                  <tr>
                    <td> &nbsp </td>
                      <td><input type="text" class="app-search form-control" v-model="search_uname" placeholder="Search " /></td>
                    <td><input type="text" class="app-search form-control" v-model="search_fname" placeholder="Search " /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_email" placeholder="Search email" /></td>
<!--                    <td><input type="text" class="app-search form-control" v-model="search_lname" placeholder="Search " /></td>-->
<!--                      -->
<!--                  -->
<!--                    <td> &nbsp </td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_phone" placeholder="Search " /></td>-->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(agent,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td>{{agent.users[0].username==null ? 'null' : agent.users[0].username}}</td>
                    <td>{{agent.first_name}} {{agent.last_name}}</td>
                      <td>
                          <div class="row">
                              <div class="col-xs-4">{{agent.email}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.phone_code}} {{agent.phone_number}}</div>
                          </div>
                      </td>
                      <td v-if="agent.users[0].email_verified_at==null">
                          no
                      </td>
                      <td v-else >yes</td>
                      <td>
                          <div class="row">
                              <div class="col-xs-4">{{agent.address}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.city}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.country}}</div>
                          </div>

                      <td>
                          <div class="row">
                              <div class="col-xs-4">{{agent.currency}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.language}}</div>
                          </div>

                      </td>
                      <td>
                          <b-dropdown dropright>
                              <template v-slot:button-content>
                                  Action
                                  <i class="mdi mdi-chevron-down"></i>
                              </template>
                              <b-dropdown-item><b-button class="btn btn-primary btn-sm" variant="primary" @click.prevent="sendVerificationEmail(agent)">Resend Verification</b-button></b-dropdown-item>
                              <b-dropdown-item><router-link :to="{ name: 'agent_update', params: {type:'unverified',uuid: agent.uuid}}" class="btn btn-primary btn-sm"><i class="fas fa-edit"></i> Edit</router-link></b-dropdown-item>
                              <b-dropdown-item><b-button class="btn btn-primary btn-sm" v-b-modal.modal-lg variant="primary" @click.prevent="getAgentDetails(agent)"><i class="fas fa-edit"></i>Details</b-button></b-dropdown-item>
                          </b-dropdown>
                      </td>
<!--                      <td><b-button id="ver-email" variant="primary" @click.prevent="sendVerificationEmail(agent)">Resend Verification</b-button></td>-->
<!--                      <b-tooltip target="ver-email">Resend Verification Email</b-tooltip>-->
<!--                      <td><router-link id="unver-edit" :to="{ name: 'agent_update', params: {type:'unverified',uuid: agent.uuid}}" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link></td>-->
<!--                      <b-tooltip target="unver-edit">Update User Data</b-tooltip>-->
<!--                      <td><b-button id="unver-details" v-b-modal.modal-lg variant="primary" @click.prevent="getAgentDetails(agent)"><i class="fas fa-edit"></i>Details</b-button></td>-->
<!--                      <b-tooltip target="unver-details">See Details</b-tooltip>-->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.width-20px{
    width:20px;
}
.margin-5px{
    margin-right: 5px;
}
table>tr>td{
    width:30%;
    height:30px;
}
.margin-5px{
    margin-right: 5px;
}
.width-20px{
    table-layout: fixed;
    width: 20px;
}
.padding-5px{
    padding-right: 3%;
    padding-left: 3%;
}
.table-responsive img{
    width:60px;
}
table>tr>td:nth-child(odd) {
    font-weight: 600;
}
</style>
